
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/counsellors",
      function () {
        return require("private-next-pages/counsellors/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/counsellors"])
      });
    }
  